import Vue from 'vue';
import Vuex from 'vuex';
import Login from './modules/login';
import Firstlogin from './modules/firstlogin';
import Marks from './modules/marks';
import Loading from './modules/loading';
require('es6-promise').polyfill();


Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    login: Login,
    firstlogin: Firstlogin,
    marks: Marks,
    loading: Loading
  }

})
